import api from './serviceApi'; // Import the axios instance

const dashboardApi = {
  /**
   * Fetch dashboard metrics.
   *
   * Current fields used by the dashboard:
   * QuantityOrders, QuantityOrdersAllowPayment, QuantityOrdersWaitPayment,
   * QuantityOrdersPaid, QuantityOrdersCanceledCustomer,
   * QuantityOrdersCanceledStore, QuantityOrdersExpired,
   * QuantityUnderAnalysis, QuantityTransactionsOk,
   * QuantityTransactionsNotOk, QuantityMailsSent, QuantityClients,
   * QuantityOrdersPerDay.
   *
   * TODO backend contract for richer dashboard:
   * TotalOrderValue, PaidOrderValue, AverageTicket,
   * PaidConversionRate, CancellationRate, FailedTransactionRate,
   * QuantityMailsNotSent, QuantityIntegrationErrors,
   * RecentFailedTransactions, RecentUnderAnalysisOrders,
   * RecentUnsentEmails, RecentIntegrationErrors,
   * OrdersCloseToExpiration, OrdersByStatusPerDay.
   * Keep all fields optional so older API versions remain compatible.
   *
   * @returns {Promise<Object>} - The metrics data.
   */
  getMetrics: async (params = {}) => {
    try {
      const response = await api.get('/dashboard/metrics', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard metrics:', error);
      throw error;
    }
  }
};

export default dashboardApi;
